module.exports = __webpack_public_path__ + "static/media/img-1-1200x1000.1e7c70dc.jpg";